// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.container {
  border-radius: 7px;
  box-shadow: 0px 4px 8px;
  padding: 1px 0px 20px 0px;
}

.containerconfirm {
  /* border-radius: 7px;
    box-shadow: 0px 4px 8px; */
  /* padding: 20px; */
  /* height: 250px;
    width: 350px; */
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.crossiconspan {
  width: 100%;
  display: flex;
  justify-content: flex-end;
  padding-top: 10px;
  padding-right: 10px;
}

.backgroundconfirm {
  border-radius: 7px;
  box-shadow: 0px 4px 8px;
  height: 200px;
  width: 340px;
}

.crossbutton {
  display: inline;
}

.crossbuttonconfirm {
  display: flex;
  /* justify-content: space-between; */
  flex-direction: column;
  text-align: center;
  justify-content: center;
  gap: 20px;
}

/* .container .heading h1{
    text-align: center;
    margin-top: 0px;
    margin-right: 35px;
    padding-top: 15px;
} */
.body {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 20px;
  padding: 0px 20px;
}

/* .container .heading p{
    justify-content: center;
    text-align: center;
    font-weight: 500;
    line-height: 25px;
    margin-left: 20px;
} */
.footer {
  display: flex;
  align-items: flex-start;
  justify-content: center;
  gap: 20px;
}

#canclbtn {
  background-color: grey;
  color: white;
  border-radius: 5px;
  cursor: pointer;
  border-color: grey;
}

#continuebtn {
  color: white;
  background-color: crimson;
  border-radius: 5px;
  cursor: pointer;
  border-color: crimson;
}

.crossbutton {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  padding: 10px 20px;
}

.logoutheading {
  width: 100%;
  display: flex;
  justify-content: center;
}`, "",{"version":3,"sources":["webpack://./components/ConfirmationDialog/ConfirmationDialog.css"],"names":[],"mappings":"AAAA;EACE,kBAAA;EACA,uBAAA;EACA,yBAAA;AACF;;AACA;EACE;8BAAA;EAEA,mBAAA;EACA;mBAAA;EAEA,aAAA;EACA,sBAAA;EACA,uBAAA;AAEF;;AAAA;EACE,WAAA;EACA,aAAA;EACA,yBAAA;EACA,iBAAA;EACA,mBAAA;AAGF;;AADA;EACE,kBAAA;EACA,uBAAA;EACA,aAAA;EACA,YAAA;AAIF;;AAFA;EACE,eAAA;AAKF;;AAHA;EACE,aAAA;EACA,oCAAA;EACA,sBAAA;EACA,kBAAA;EACA,uBAAA;EACA,SAAA;AAMF;;AAJA;;;;;GAAA;AAMA;EACE,aAAA;EACA,sBAAA;EACA,mBAAA;EACA,uBAAA;EACA,SAAA;EACA,iBAAA;AAOF;;AALA;;;;;;GAAA;AAQA;EACE,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,SAAA;AAOF;;AAJA;EACE,sBAAA;EACA,YAAA;EACA,kBAAA;EACA,eAAA;EACA,kBAAA;AAOF;;AALA;EACE,YAAA;EACA,yBAAA;EACA,kBAAA;EACA,eAAA;EACA,qBAAA;AAQF;;AALA;EACE,aAAA;EACA,mBAAA;EACA,8BAAA;EACA,kBAAA;AAQF;;AANA;EACE,WAAA;EACA,aAAA;EACA,uBAAA;AASF","sourcesContent":[".container {\n  border-radius: 7px;\n  box-shadow: 0px 4px 8px;\n  padding: 1px 0px 20px 0px;\n}\n.containerconfirm {\n  /* border-radius: 7px;\n    box-shadow: 0px 4px 8px; */\n  /* padding: 20px; */\n  /* height: 250px;\n    width: 350px; */\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n}\n.crossiconspan {\n  width: 100%;\n  display: flex;\n  justify-content: flex-end;\n  padding-top: 10px;\n  padding-right: 10px;\n}\n.backgroundconfirm {\n  border-radius: 7px;\n  box-shadow: 0px 4px 8px;\n  height: 200px;\n  width: 340px;\n}\n.crossbutton {\n  display: inline;\n}\n.crossbuttonconfirm {\n  display: flex;\n  /* justify-content: space-between; */\n  flex-direction: column;\n  text-align: center;\n  justify-content: center;\n  gap: 20px;\n}\n/* .container .heading h1{\n    text-align: center;\n    margin-top: 0px;\n    margin-right: 35px;\n    padding-top: 15px;\n} */\n.body {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  gap: 20px;\n  padding: 0px 20px;\n}\n/* .container .heading p{\n    justify-content: center;\n    text-align: center;\n    font-weight: 500;\n    line-height: 25px;\n    margin-left: 20px;\n} */\n\n.footer {\n  display: flex;\n  align-items: flex-start;\n  justify-content: center;\n  gap: 20px;\n}\n\n#canclbtn {\n  background-color: grey;\n  color: white;\n  border-radius: 5px;\n  cursor: pointer;\n  border-color: grey;\n}\n#continuebtn {\n  color: white;\n  background-color: crimson;\n  border-radius: 5px;\n  cursor: pointer;\n  border-color: crimson;\n}\n\n.crossbutton {\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  padding: 10px 20px;\n}\n.logoutheading {\n  width: 100%;\n  display: flex;\n  justify-content: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
